import ReviewsPageHero from '$lib/storyblok/blocks/reviewsPageHero.svelte';
import ReviewsPage from '$lib/storyblok/pages/reviewsPage.svelte';
import defaultComponents from '$lib/storyblok/defaultComponents';
import { registerComponents } from '$lib/storyblok/sdk';

registerComponents({
	...defaultComponents,
	reviews_page: ReviewsPage,
	reviews_page_hero: ReviewsPageHero
});
